import React from 'react';
import './CSS/exhibitions.css';
import exhibition1 from '../src/Images/exhibition1.jpg';
import exhibition2 from '../src/Images/exhibition2.jpg';
import exhibition3 from '../src/Images/exhibition3.jpg';
import exhibition4 from '../src/Images/exhibition4.JPG';

function Exhibitions() {
  return (
    <div className="exhibitions-background">
      <h1 className="monoton_title exhibition-page-title">Exhibitions</h1>
      <div class="exhibitions_container">
        <div className="exhibitions">
          <div className="exhibition_section">
            <h3 className="exhibition_title">Local Artists Group Exhibiition</h3>
            <div className="exhibition_date">August 2020</div>
            <div className="exhibition_description">Blue Moon Cafe, Sheffield</div>
          </div>
          <div className="exhibition_section">
            <h3 className="exhibition_title">Creating a togetherness</h3>
            <div className="exhibition_date">March-April 2020</div>
            <div className="exhibition_description">West Studios, Chesterfield</div>
          </div>
          <div className="exhibition_section">
            <h3 className="exhibition_title">Local Artist of the Month</h3>
            <div className="exhibition_date">October 2019</div>
            <div className="exhibition_description">Solo Exhibition in Copper Pot Cafe, Sheffield</div>
          </div>
          <div className="exhibition_section">
            <h3 className="exhibition_title">Open Exhibition</h3>
            <div className="exhibition_date">September 2019</div>
            <div className="exhibition_description">West Studios, Chesterfield</div>
          </div>
          <div className="exhibition_section">
            <h3 className="exhibition_title">Communicate Solo Exhibition</h3>
            <div className="exhibition_date">July 2019</div>
            <div className="exhibition_description">West Studios, Chesterfield</div>
          </div>
          <div className="exhibition_section">
            <h3 className="exhibition_title">Albion Arts</h3>
            <div className="exhibition_date">May 2019</div>
            <div className="exhibition_description">The Albion Pub, Sheffield</div>
          </div>
          <div className="exhibition_section">
            <h3 className="exhibition_title">Art in Black and White</h3>
            <div className="exhibition_date">October 2018</div>
            <div className="exhibition_description">Union Street, Sheffield</div>
          </div>
        </div>
        <div class="exhibition_posters">
          <div className="img__container">
            <div className="image" id="grid_item_1">			
              <img src={exhibition1} alt="Exhibition poster" />
            </div> 
          </div>
          <div className="img__container">
            <div className="image" id="grid_item_2">			
              <img src={exhibition2} alt="Exhibition poster" />
            </div> 
          </div>
          <div className="img__container">
            <div className="image" id="grid_item_3">			
              <img src={exhibition3} alt="Exhibition poster" />
            </div> 
          </div>
          <div className="img__container">
            <div className="image" id="grid_item_4">			
              <img src={exhibition4} alt="Exhibition poster" />
            </div> 
          </div>
        </div>
      </div>
    </div>
  );
}

export default Exhibitions;
